import PaginatorSwitcher from './PaginatorSwitcher';
export default PaginatorSwitcher;
